import Vue from 'vue';
import Vuex from 'vuex';
import actions from './event-actions';
import getters from './event-getters';
import mutations from './event-mutations';
import state from './event-state';

Vue.use(Vuex);
export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
